import React from "react";
import { useRouteMatch, Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Logo } from "../Logo";

type SideNavigationItem = {
    name: string;
    to: string;
    icon: any
};

interface INavProps {
    navigation: SideNavigationItem[]
}

const SideBarNav = ({navigation, ...props}: INavProps ) => {
    useRouteMatch();

    return (
        <ul className="nav nav-pills nav-flush flex-column flex-nowrap mb-auto mx-auto w-100 mt-3">
            {navigation.map((item, index) => (
                <li className="nav-item" key={item.name}>
                    <Link className="align-items-center d-flex nav-link px-2 py-2" title={item.name} to={item.to}>
                        <FontAwesomeIcon className="fa-1x mr-2" icon={item.icon} /> {item.name}
                    </Link>
                </li>
            ))}
        </ul>
    );
}

const SideBar = (props: any) => {
    return (
        <div className="d-flex flex-column flex-nowrap bg-dark sticky-top" style={{ width: "200px" }}>
            <div>
                <div className="my-2">
                    <Logo {...props} />
                </div>
                <SideBarNav {...props} />
            </div>
        </div>
    );
}

type MainLayoutProps = {
    children: React.ReactNode;
};

export const MainLayout = ({ children, ...props }: MainLayoutProps) => {
    return (
        <div>
            <div className="d-flex">
                <div className="col-auto bg-dark sticky-top">
                    <SideBar {...props}/>
                </div>
                <main className="min-vh-100-1 w-100">
                    {children}
                </main>
            </div>
        </div>
    );
}
